// extracted by mini-css-extract-plugin
var _1 = "membership--verification-module__form--btn--L2FwcC";
var _2 = "membership--verification-module__form--login--L2FwcC";
var _3 = "membership--verification-module__inputs--L2FwcC";
var _4 = "membership--verification-module__login--body--L2FwcC";
var _5 = "membership--verification-module__login--form--L2FwcC";
var _6 = "membership--verification-module__login--input--L2FwcC";
var _7 = "membership--verification-module__login--title--L2FwcC";
var _8 = "membership--verification-module__logo--web--L2FwcC";
var _9 = "membership--verification-module__sso--L2FwcC";
var _a = "membership--verification-module__success--div--L2FwcC";
var _b = "membership--verification-module__title--form--L2FwcC";
var _c = "membership--verification-module__verification--title--L2FwcC";
var _d = "membership--verification-module__verify--new--L2FwcC";
export { _1 as "formBtn", _2 as "formLogin", _3 as "inputs", _4 as "loginBody", _5 as "loginForm", _6 as "loginInput", _7 as "loginTitle", _8 as "logoWeb", _9 as "sso", _a as "successDiv", _b as "titleForm", _c as "verificationTitle", _d as "verifyNew" }
